import { useEffect } from 'react';
import Conditional from '@app/components/common/Conditional';
import { useModal, Modal } from 'cat-ecommerce-alloy';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ReplacementPartsModal from '../../QuickOrder/ReplacementPartsModal';
import { ModalVariant } from 'cat-ecommerce-alloy/dist/components/alloy-modal-v2/Modal.types';
import {
  RESET_REPLACED_PARTS_INFO,
  RESET_REPLACED_PARTS_INFO_STATUS
} from '@app/store/orders/constants';
import { getDealerPriceAndAvailabilityReplacementWithReplacement } from '@app/store/checkout/actions';
import PropTypes from 'prop-types';

const ReplacementParts = ({
  isAvailabilityToggled,
  setIsAvailabilityToggled
}) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const replacementPartsModalProps = useModal();
  const isOrderPriceAvailabilityLoading = useSelector(
    s => s.orders.isOrderPriceAvailabilityLoading
  );
  const isPriceLoadComplete = useSelector(s => s.orders.isPriceLoadComplete);
  const replacedParts = useSelector(s => s.orders.replacedParts);
  const orderHasReplacements = !!replacedParts?.length;
  const currentAddToCartModifications =
    useSelector(s => s.checkout.currentAddToCartModifications.items) ?? [];
  const hasReplacements = useSelector(
    s => s.checkout.currentAddToCartHasReplacement
  );

  useEffect(() => {
    if (
      !isOrderPriceAvailabilityLoading &&
      isPriceLoadComplete &&
      hasReplacements
    ) {
      dispatch({ type: RESET_REPLACED_PARTS_INFO_STATUS });
      if (orderHasReplacements) {
        dispatch(getDealerPriceAndAvailabilityReplacementWithReplacement());
        if (currentAddToCartModifications.length) {
          replacementPartsModalProps.open();
        }
      } else {
        replacementPartsModalProps.close();
        dispatch({ type: RESET_REPLACED_PARTS_INFO });
      }
    }
  }, [
    currentAddToCartModifications.length,
    dispatch,
    isOrderPriceAvailabilityLoading,
    isPriceLoadComplete,
    orderHasReplacements,
    replacementPartsModalProps
  ]);

  return (
    <Conditional test={orderHasReplacements}>
      <Modal
        contentLabel={t('QUICK_ORDER_REPLACEMENT_PARTS')}
        contentClassName="pb-0"
        isOpen={replacementPartsModalProps.isOpen}
        title={t('QUICK_ORDER_REPLACEMENT_PARTS')}
        variant={ModalVariant.large}
      >
        <ReplacementPartsModal
          modalOptions={replacementPartsModalProps}
          isAvailabilityToggled={isAvailabilityToggled}
          setIsAvailabilityToggled={setIsAvailabilityToggled}
        />
      </Modal>
    </Conditional>
  );
};

ReplacementParts.propTypes = {
  isAvailabilityToggled: PropTypes.bool,
  setIsAvailabilityToggled: PropTypes.func
};

export default ReplacementParts;
